import 'rxjs/add/observable/throw';

import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { DateUtils } from '../../shared/_utils/services/dateUtils';
import { MemoType } from '../entities/memoType';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';

@Injectable()
export class MemoTypeService extends BaseCrudService<MemoType> {

    public uri = '/api/memoType/';
    //private currentFiscalYear: FiscalYear;

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance memoTypeService');
        //this.findCurrentFiscalYear();
    }
 

    buildSentence(entity?: MemoType, event?: LazyLoadEvent): HttpParams {
        if (entity) {
            let query = entity.code ? 'code'
                + QueryOperator.Contain + entity.code
                + QueryOperator.Split : QueryOperator.Empty;
            query = query.concat(
                entity.name ? 'name'
                + QueryOperator.Contain + entity.name
                + QueryOperator.Split : QueryOperator.Empty
            );

            query = query.concat(
                entity.documentType ? 'documentType.id'
                + QueryOperator.Equal + entity.documentType.id
                + QueryOperator.Split : QueryOperator.Empty
            );
            
            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1 ).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/memo-type.service.ts